import $ from 'jquery';
import { throttle } from 'throttle-debounce';
import axios from 'axios';

import sharedVars from '../../shared-vars.json';
import { Component } from '../core/component';

const { 'tablet-large': tabletLarge } = sharedVars.breakpoints;

export class EventCalendar extends Component {
    constructor() {
        super();
        this.selector = '.js-event-calendar';
        this.$miniCalendar = null;
        this.$eventPreviews = null;
        this.tabletLargeMqL = null;
        this.electedDate = null;
    }

    init() {
        this.$miniCalendar = this.$elements.find('.js-mini-calendar-wrapper');
        this.$eventPreviews = this.$elements.find('.js-event-day-preview-wrapper');
        this.tabletLargeMqL = window.matchMedia(`(max-width: ${tabletLarge}px)`);

        this.$miniCalendar.on('click', '.js-mini-cal-month-link', e => this.changeMonth(e));
        this.$miniCalendar.on('click', '.js-mini-cal-day-link', e => this.updatePreviews(e));
        this.setEventPreviewHeight();

        $(window).on('resize', throttle(50, () => {
            this.setEventPreviewHeight();
        }));
    }

    async changeMonth(evt) {
        evt.preventDefault();

        const params = this.getExistingQueryParameters();
        const url = $(evt.currentTarget).attr('href');

        const res = await axios.get(url + params);

        this.$miniCalendar.html(res.data);

        this.setEventPreviewHeight();
    }

    async updatePreviews(evt) {
        evt.preventDefault();

        const $el = $(evt.currentTarget);

        const params = this.getExistingQueryParameters();
        const url = $el.attr('href');

        const res = await axios.get(url + params);
        this.$miniCalendar.find('a').removeClass('is-active');
        $el.addClass('is-active');

        this.selectedDate = $el.data('date');

        this.$eventPreviews.html(res.data);
    }

    getExistingQueryParameters() {
        let existingParams = window.location.search;
        if (existingParams) {
            existingParams = `&${existingParams.substr(1)}`;
        }

        if (this.selectedDate) {
            existingParams += `&selectedDate=${this.selectedDate}`;
        }

        return existingParams;
    }

    setEventPreviewHeight() {
        let height = 'auto';

        if (!this.tabletLargeMqL.matches) {
            height = `${this.$miniCalendar[0].offsetHeight}px`;
        }

        this.$eventPreviews[0].style.height = height;
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/eventCalendar.js